import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { reduce, filter, property, flatten, map, isEmpty } from 'lodash';

import ReportSummary from '../../components/seller/SellerReportSummary';

const getRevenue = items => {
    const sumFn = (sum, item) => item.quantity * item.price + sum;
    const total = reduce(items, sumFn, 0);
    const cash = reduce(
        filter(items, item => item.paymentType === 'CASH'),
        sumFn,
        0,
    );
    const gift = reduce(
        filter(items, item => item.paymentType === 'GIFT'),
        sumFn,
        0,
    );
    const membership = reduce(
        filter(items, item => item.paymentType === 'MEMBERSHIP'),
        sumFn,
        0,
    );

    return {
        total,
        cash,
        gift,
        membership,
        cc: total - cash - gift - membership,
    };
};

const sumQuantity = items =>
    reduce(items, (sum, item) => sum + item.quantity, 0);

function SellerReportSummary(props) {
    const { sellers } = props;
    const showAppRecords = useSelector(({ report }) =>
        report.get('showAppRecords'),
    );

    const summary = useMemo(() => {
        let invoices = flatten(map(sellers, property('report.invoices')));

        if (showAppRecords) {
            invoices = filter(
                invoices,
                ({ appointments }) =>
                    !isEmpty(appointments) &&
                    appointments[0].authorRole !== 'ADMIN',
            );
        }

        const items = flatten(map(invoices, property('items')));

        const services = filter(items, item => item.type === 'SERVICE');
        const products = filter(items, item => item.type === 'PRODUCT');

        return {
            numOfServices: sumQuantity(services),
            numOfProducts: sumQuantity(products),
            revenueOfServices: getRevenue(services),
            revenueOfProducts: getRevenue(products),
        };
    }, [sellers, showAppRecords]);

    return <ReportSummary {...props} summary={summary} />;
}

export default SellerReportSummary;
